export default "__VITE_ASSET__cd997856__"